// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_mk-0";
export var buttonContainer = "_mk-3";
export var cancelButton = "_mk-4";
export var headerSection = "_mk-6";
export var headerTitle = "_mk-9";
export var messageSideLeft = "_mk-1";
export var messageSideRight = "_mk-2";
export var orderNumberContainer = "_mk-7";
export var orderNumberLabel = "_mk-8";
export var submitButton = "_mk-5";